
function startupStateReducer(state = {}, action = {} as any) {

  switch (action.type) {
    case 'BOL_DATA':
      return {
        ...state,
        ...action.payload
      }
    case 'BOL_NO':
      return {
        ...state,
        bolNo: action.payload
      }
    default:
      return state;
  }
}

export default startupStateReducer;
